
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { AssetClassSource } from '@/Sources';

  @Component({
    name: 'asset-class-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class AssetClassDropdownField extends Vue {
    @Prop() public value!: number;
    @Prop({ default: 'Asset' }) public label!: string;
    @Prop({ default: '' }) public errorText!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;

    public source: AssetClassSource = new AssetClassSource();

    public get val(): number { return this.value; }
    public set val(value: number) {

      this.$emit('input', value);
    }
  }
